function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 109 70"
}, props), React.createElement("path", {
  d: "M57.35 48.566C42.078 57.14 26.056 63.54 15.375 67.382 9.383 69.539 2.761 65.789 2.67 60.177l-.668-39.92C1.812 9.176 13.146.586 25.837 2.193 47.715 4.967 77.065 8.219 97.41 7.255c7.427-.354 12.176 6.792 8.079 12.155-8.026 10.517-22.765 23.766-48.14 29.156z",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M57.35 48.566s8.443-8.576 2.503-30.067M71.77 6.816l6.106 5.219-4.969 4.989 6.866 5.868-5.235 4.78 6.077 5.454M85.045 7.38l4.885 4.275-4.475 4.418 4.703 3.901",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M50.363 9.51c-9.171-.924-17.925-1.98-25.276-2.91a18.268 18.268 0 00-2.314-.145c-4.195 0-8.147 1.436-11.12 4.045-2.96 2.597-4.56 6.038-4.499 9.69l.394 23.471c4.438-8.103 12.487-23.687 42.823-34.15h-.008z",
  fill: "#357287"
})));